import { ENDPOINT_QUOTES_DRAFT, ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

/**
 * Patch draft
 * @param {object} draft
 */
const patchDraft = ({ draft }) => {
  const params = { ...draft };

  // Delete the id to adapt the payload of the patch
  delete params.id;

  return axiosAuth
    .patch(`${ENDPOINT_ROOT}/${ENDPOINT_QUOTES_DRAFT}/${draft.id}`, params)
    .then((res) => res.data);
};

export default patchDraft;
